<template>
    <div class="timeline">
        <!-- timeline button -->
        <router-link
            :to="{ name: ''}"
            v-b-modal.timeline-modal
            class="d-flex justify-content-sm-start justify-content-center align-items-center mb-3 text-decoration-none"
        >
            <div class="schedule d-flex justify-content-center align-items-center" :style="'--category-color:' + categoryInfo.color">
                <img src="@/assets/images/icon_calendrier@2x.png" :alt="$t('timeline-button')" />
            </div>
            <div class="years d-flex justify-content-center align-items-center" v-if="selectedDates">
                <button class="btn d-flex justify-content-between align-items-center" :style="'--category-color:' + categoryInfo.color">
                    {{ `${selectedDates.from}–${selectedDates.to}` }}
                    <font-awesome-icon :icon="['fas', 'chevron-right']" />
                </button>
            </div>
        </router-link>

        <!-- Timeline Modal -->
        <b-modal
            id="timeline-modal"
            scrollable
            centered
            size="md"
            @ok="applyChange"
            :static="isStatic"
            :modal-class="[vibility, {animationsActive: animationsToggle}]"
            @shown="getLeftLinePadding(); addDelay();"
            @hidden="onClose()"
            :no-fade="!animationsToggle"
            hide-header
        >
            <div class="timeline-content d-flex flex-column align-items-center" v-bind:class="[fontSizeSetting, {openDyslexicFont: openDyslexicToggle}]">
                <b-button class="mt-3 close" aria-label="Close"  block @click="$bvModal.hide('timeline-modal')">X</b-button>
                <div class="schedule d-flex justify-content-center align-items-center mb-2" :style="'--category-color:' + categoryInfo.color">
                    <img src="@/assets/images/icon_calendrier@2x.png" alt="" height="40">
                </div>
                <p class="m-0 text-center modal-title"> {{ categoryInfo.description }} </p>
                <div class="timeline-body">
                    <span class="big-text m-0 d-flex align-items-end" :style="'--category-color:' + categoryInfo.color">
                        {{ lastDate }}
                    </span>
                    <div class="px-sm-3 d-flex justify-content-sm-start" :class="withDescription ? 'justify-content-center' : 'justify-content-start px-3'">
                        <div class="left-hr" :style="'--padding:' + leftLinePadding">
                            <hr class="p-0 timeline" :style="'--category-color:' + categoryInfo.color">
                        </div>
                        <div class="timeline-sections w-100">
                            <div
                                v-for="(date, index) in dates"
                                :key="date.id"
                                class="timeline-date d-flex align-items-center"
                                :ref="`section-${index}`"
                                :class="[(index !== dates.length - 1) ? 'mb-3' : null, (!animationsToggle || animationBeat >= index +3)? 'animate':'', `timeline-${index}`]"
                            >
                                <span class='dot' :style="'--category-color:' + categoryInfo.color"></span>
                                <button
                                    class="date text-center"
                                    :style="`--category-color: ${categoryInfo.color}`"
                                    :class="[
                                        (newDates && (date.from === newDates.from) && (date.to === newDates.to) ) ? 'active': null,
                                        (index % 2 !== 0) ? 'second' : null
                                    ]"
                                    @click="selectDates(date, index)"
                                >
                                    <img src="../../assets/images/poppyflower@2x.png" alt="" v-if="date.marked">
                                    {{ `${date.from}–${date.to}` }}
                                    <small class="d-block" :style="'--category-color:' + categoryInfo.color" v-if="date.description">
                                        {{ $t(`timeline-info.${date.description}`) }}
                                    </small>
                                </button>
                            </div>
                        </div>
                    </div>
                    <span class="big-text m-0 d-flex justify-content-end" :style="'--category-color:' + categoryInfo.color">
                        {{ firstDate }}
                    </span>
                </div>
            </div>
             <template #modal-footer="{ ok }">
                <b-button variant="primary" @click="ok()" >
                    <p class="m-0 apply" v-bind:class="[fontSizeSetting, {openDyslexicFont: openDyslexicToggle}]">{{ $t('apply') }}</p>
                </b-button>
            </template>
        </b-modal>
    </div>
</template>
<script>

// Helpers
import { EventBus } from '@/helpers/EventBus.js';
import { Default }  from '@/helpers/Default.js';

export default {
    props: [ 'categoryInfo', 'dates'],
    data () {
        return {
            animationBeat:      0,
            spacer:             false,
            fadeinInterval:     null,
            animationsToggle:   Default.animationsToggle,
            openDyslexicToggle: Default.openDyslexicToggle,
            fontSizeSetting:    Default.size,
            firstDate:          '',
            lastDate:           '',
            leftLinePadding:    '',
            vibility:           'visible-modal',
            isStatic:           true,
            selectedDates:      null,
            newDates:           null,
            withDescription:    false
        };
    },
    mounted() {
        if (this.$session.has('openDyslexicToggle')) {
            this.openDyslexicToggle = this.$session.get('openDyslexicToggle');
        }

        if (this.$session.has('animationsToggle')) {
            this.animationsToggle = this.$session.get('animationsToggle');
        }

        this.fontSizeSetting = this.$session.get('growFont');

        // Listen for OpenDyslexic font setting value
        EventBus.$on('settingsChanged', (setting) => {
            this[setting.name] = setting.value;
        });

        // Update the setting window too when the font size changes
        EventBus.$on('grow-font', this.changeFontSize);

        // Update the selected dates.
        EventBus.$on('update-dates', this.updateDates);
    },
    watch: {
        dates () {
            if (this.dates.length > 0) {
                this.initDates();

                // Check if this timeline is with descriptions.
                this.checkDescription();

                // Get the first and the last dates
                this.getFirstAndLastDates();

                this.getLeftLinePadding();
            }
        }
    },
    methods: {
        /**
         * Init dates
         */
        initDates () {
            this.selectedDates          = this.dates[0];
            this.newDates               = this.dates[0];
            this.selectedDates.index    = 0;
            this.selectedDates.firstOne = true;
            this.selectedDates.lastOne  = false;

            this.$emit('changeDates', this.selectedDates);
        },

        /**
         * Check if this timeline is with descriptions (at least one have description).
         */
        checkDescription () {
            this.dates.forEach(date => {
                if (date.description !== null) {
                    this.withDescription = true;
                    return
                }
            });
        },

        /**
         * Update the setting page when font size changes
         */
        changeFontSize () {
            this.fontSizeSetting = this.$session.get('growFont');
        },

        /**
         * Get the First and the Last dates
         */
        getFirstAndLastDates () {
            this.firstDate = this.dates[this.dates.length - 1].from;
            this.lastDate  = this.dates[0].to;
        },

        /**
         * Select a new dates
         *
         * @param   {object}     date     the selected dates
         * @param   {integer}    index    the index of the new dates
         */
        selectDates (date, index) {
            this.newDates          = date;
            this.newDates.index    = index;
            this.newDates.lastOne  = (this.dates.length === (index + 1)) ? true : false;
            this.newDates.firstOne = (index === 0) ? true : false;
        },

        /**
         * Update date from comparing modal
         *
         * @param   {string}     sens     go to previous or next dates.
         */
        updateDates (event) {
            var newIndex           = (event.sens === 'next') ? event.index + 1 : event.index - 1;
            this.newDates          = this.dates[newIndex];
            this.newDates.index    = newIndex;
            this.newDates.lastOne  = (this.dates.length === (newIndex + 1)) ? true : false;
            this.newDates.firstOne = (newIndex === 0) ? true : false;
            this.applyChange();

            // Change compaing data.
            setTimeout(() => {
                EventBus.$emit('change-compare-with', {
                    'sens':  'next',
                    'index': -1
                });
            }, 20);
        },

        /**
         * Call the parent component to apply the date change.
         */
        applyChange () {
            this.selectedDates = this.newDates;
            this.$emit('changeDates', this.newDates);
        },

        /**
         * Calcul the left line padding
         */
        getLeftLinePadding () {
            setTimeout(() => {
                var firstSection     = this.$refs['section-0'][0].clientHeight;
                var lastSection      = this.$refs[`section-${this.dates.length - 1}`][0].clientHeight;
                this.leftLinePadding = `${firstSection/2}px 0 ${lastSection/2}px 0`;
                this.vibility        = 'invisible-modal';
                this.isStatic        = false;
            }, 10);
        },
        /**
         * Prepares the interval for the animation beats to sync up when the modal opens
         */
        addDelay () {
            this.animationBeat = 0;
            if (!this.animationsToggle) {
                this.spacer = true;
                setTimeout(() => {
                    this.spacer = false;
                }, 500);
                return;
            }

            this.fadeinInterval = setInterval(() => {
                this.animationBeat++;

                if (this.animationBeat >= 30) {
                    clearInterval(this.fadeinInterval);
                    return;
                }
            }, 400);
        },
        /**
         * When the modal close clear the interval and reset the animation beats
         */
        onClose () {
            this.newDates = this.selectedDates;
            clearInterval(this.fadeinInterval);
            this.animationBeat = 0;
        }
    }
}
</script>
